import React, { useRef } from 'react';
import Navbar from '../components/Internal-nav';  
import emailjs from 'emailjs-com';
import './contact.scss';
import KometsBanner from '../components/komets-banner';
  
function Contact() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_svho88x', 'template_5j83yf5', form.current, 'user_o3jw2KhboyHlHGrJUr4lS')
      .then((result) => {
        alert('Email sent successfully!');
      }, (error) => {
        alert('An error occurred while sending the email. Please try again.');
      });
  };


    return (
      <div className='App'>
      <header>
        <Navbar />
      </header>
      <div>
        <div className='inner-banner' style={{ backgroundImage: "url(../assets/example-contact-banner.jpg)"}}>
          <div className='banner-content'>
          <h1>Contact Our Team</h1>
          </div>
        </div>
       
      <div className='container'>
        <div className='contact-page'>
        <div className='contact-info'>
          <h2>Let's Talk</h2>
          <p>Our team is uniquely suited to guiding you though the process of selecting cabinets, countertops, sinks, and more. Reach out today to get started!</p>
        
        <div className='contact-deets'>
          <div className='address'>
            <strong>BC Surface Supply</strong><br/>
            5216 Keystone Drive<br/>
            Fort Wayne, IN 46825
          </div>
          <div className='phone'>
            (260) 321-3092
          </div>
          <div className='email'>
            info@bcsurfacesupply.com
          </div>
        </div>
        </div>

        <div className='contact-form'>
        <form className="contact" ref={form} onSubmit={sendEmail}>
          <label htmlFor="user_name">Name</label>
          <input type="text" id="user_name" name="user_name" />

          <label htmlFor="user_email">Email</label>
          <input type="email" id="user_email" name="user_email" />

          <label htmlFor="user_subject">Subject</label>
          <input type="text" id="user_subject" name="user_subject" />

          <label htmlFor="message">Message</label>
          <textarea rows="5" name="message" id="message" />

          <input className='button' type="submit" value="Send Message" />
      </form>
        </div>
      </div>

      </div>
      </div>
      <KometsBanner></KometsBanner>
      </div>
    );
  };
  
export default Contact;